"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusiveListItem = void 0;
var React = require("react");
var ExclusiveListItem = /** @class */ (function (_super) {
    __extends(ExclusiveListItem, _super);
    function ExclusiveListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.setActiveItemIndex = function (indexToSet, cb) {
            _this.setState({
                activeItemIndex: indexToSet
            }, cb);
        };
        _this.state = {
            activeItemIndex: undefined
        };
        return _this;
    }
    ExclusiveListItem.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.props.children({
            activeItemIndex: this.state.activeItemIndex,
            setActiveItemIndex: this.setActiveItemIndex
        })));
    };
    return ExclusiveListItem;
}(React.Component));
exports.ExclusiveListItem = ExclusiveListItem;
//# sourceMappingURL=index.js.map